export default "__VITE_ASSET__Qa5D8E9s__"